// let ENV = process.env

module.exports = {
  recruit_01: {
    header_00_text_01: '創造安全安心的價値',
    header_01_text_01: '創造安全安心的價値',
    header_01_text_02: '電氣分解的必要性',
    card_01_text_01: '電氣分解効果可製造鹼性水和酸性水2種機能的水、鹼性水具有洗浄効果、而酸性水則具有殺菌除臭功能。水本身是非常容易溶入物質的液體、但不溶於油。油水會分離。',
    card_01_text_02: '使用清潔劑的目的多為去汚作用、通常清潔劑的成分是含有溶解油分的【乳化成分】。簡單的説、要能減弱表面張力的成分、也就是所謂的界面活性劑。',
    card_01_text_03: '水有不溶於油的特性、所以需要使用界面活性劑。界面活性劑裏含有油分及乙醇。水和油混合後、會產生白濁的油分残留、必須沖洗才能清除。',
    card_01_text_04: '減少沖洗水量等於減少環境汚染、少残留、製品材質不易受損、清潔物不要劣化、減短清掃時間、如有安全安心的清潔剤等等…。',
    card_01_text_05: '為能解決以上需求與課題、進而研究開發、利用特殊電解方式製造出安定的鹼性水、可將水的洗浄能力最大化並取名為加電水。',
    card_01_text_06: '和其他鹼性清潔劑的不同',
    header_02_text_01: '循環運作流程圖',
    header_03_text_01: '加電水的製造方法',
    header_03_text_02: '清潔的目的',
    card_02_text_01: '清潔的目的',
    card_02_text_02: '環境衛生管理、美観維持、安全管理都可提昇企業價値及顧客對企業的良好印象。提供訪客及工作人員一個清潔及安全的工作環境。',
    card_02_text_03: '保護企業的重要資産的同時、企業環境的清潔和維持安全都是定期保養清潔的主要目的。',
    card_02_text_04: '',
    card_03_text_01: '加電水的製造方法',
    card_03_text_02: '一般的電解装置上有、電極的【＋】陽極和【−】陰極、陰極部分可製造出鹼性水、陽極部分則是製造出酸性水。',
    card_03_text_03: '但加電水的電解製成装置是不會製造出酸性水的電解方法。清潔水所需要的是強鹼水、所以生産性能穩定的鹼性水是此装置的最大特色。',
    card_03_text_04: '加電水是目前業界唯一能單由電解方式製造出ｐH13.2以上高強鹼數値的電解水。',
    card_04_text_01: '加電水的製造方法',
    card_04_text_02: '加電水不同於一般市售的單純將水和鹼鹽溶液混合利用電解方式製造出的電解水、而是用純水加上特殊電解方式所生成的環境清潔水。',
    card_04_text_03: '製造pH13.0的電解方法是使用特殊的循環型荷電水方式、',
    card_04_text_04: '加入0.25％的碳酸鉀當電解輔助劑、使用特殊的循環型荷電水方式製造、20L的加電水需花70分鐘運作生産。',
    card_04_text_05: '一般掺有界面活性劑及氫氧化鈉的洗潔劑所含的ＯＨ-和純水所生産出的加電水的ＯＨ-是不同性質。',
    card_05_text_01: '加電水的製造方法',
    card_05_text_02: '製造1公升的pH12.7〜pH13加電水需要加入0.25％的碳酸鉀當電解質、但1公升的水摻入9ｇ的小蘇打或18g的碳酸鉀可調配出pH11.5的水溶液。',
    card_05_text_03: '這表示單純用ｐH値的高低是無法判断危険性、即使只有ｐH11的離子物質、含量越多刺激性也越大。',
    card_05_text_04: '相對的、離子物質含量越多、ｐH値在使用期限内、品質維持越穩定。',
    card_05_text_05: '中性清潔劑的話、因摻入油脂及防腐劑所以ｐH値不會有太大的變化。',
    footer_text_01: '家',
    footer_text_02: '創造安全安心的價値'
  },
  recruit_02: {
    header_00_text_01: '電解鹼性水-<br class="sp">加電水的產品説明',
    header_01_text_01: '電解鹼性水-<br class="sp">加電水的產品説明',
    header_01_text_02: '電氣分解的必要性',
    card_01_text_01: '電氣分解効果可製造鹼性水和酸性水2種機能的水、鹼性水具有洗浄効果、而酸性水則具有殺菌除臭功能。水本身是非常容易溶入物質的液體、但不溶於油。油水會分離。',
    card_01_text_02: '使用清潔劑的目的多為去汚作用、通常清潔劑的成分是含有溶解油分的【乳化成分】。簡單的説、要能減弱表面張力的成分、也就是所謂的界面活性劑。',
    card_01_text_03: '水有不溶於油的特性、所以需要使用界面活性劑。界面活性劑裏含有油分及乙醇。水和油混合後、會產生白濁的油分残留、必須沖洗才能清除。',
    card_01_text_04: '減少沖洗水量等於減少環境汚染、少残留、製品材質不易受損、清潔物不要劣化、減短清掃時間、如有安全安心的清潔剤等等…。',
    card_01_text_05: '為能解決以上需求與課題、進而研究開發、利用特殊電解方式製造出安定的鹼性水、可將水的洗浄能力最大化並取名為加電水。',
    header_02_text_01: '加電水的製造方法',
    header_02_text_02: '製造流程',
    card_02_text_01: '製造流程',
    card_02_text_02: '首先用軟水装置先將自來水處理過。處理目的是要將自來水裏的鈣質去除。電氣分解的時候、鈣質會附著在電極上、附著過多會造成無法穩定電解。',
    card_02_text_03: '活性炭過濾器及ＰＰ過濾器可將氯和不純物質去除。',
    card_02_text_04: '使用純水裝置事先将純水製好。純水是去除了所有離子物質、鹽類及其他有機物等不純物質、是純度非常高的水。為減少重覆沖洗次數、不含残留物質的水是最好。純水也是在電氣分解時能穩定運作的重要關鍵。',
    card_03_text_01: '提昇洗浄能力的重點',
    card_03_text_02: '改變使用方法及添加藥品等都可提昇洗浄能力で洗浄能力、但是最安全及最快的方法是提高水的温度。通常加熱是最簡單的提昇洗浄力的方法。',
    card_03_text_03: '最常見的例子就是用鐵板烤肉時、為清洗黏在鐵板上的焦黑油漬、利用鐵板還處高溫狀態時、沖水清洗油汚就很容易被分解洗掉。',
    card_03_text_04: '這是因為表面張力變小油汚容易剝落的現象。表面張力變小可讓汙漬容易剝落、提高ｐＨ値和水温、都能讓表面張力變小、提高洗浄効果。',
    card_04_text_01: '加電水的清潔特色 優點',
    card_04_text_02: '不必重複擦拭(提高作業効率)。',
    card_04_text_03: '不影響人體健康。',
    card_04_text_04: '低残留性又衛生、可長時間保持外観的清潔。',
    card_04_text_05: '非常環保。',
    card_04_text_06: '對清潔油汚非常有効。',
    card_04_text_07: '維持穏定的品質。',
    card_04_text_08: '具有殺菌、消臭的効果。',
    card_05_text_01: '加電水的清潔特色 弱點',
    card_05_text_02: '浸泡洗濯時、油分會浮上水面、有可能造成再附着問題、所以必須再次沖洗。',
    card_05_text_03: '因不會産生泡沫、在清洗牆壁等垂直面時、水會直接流下、所以要斟酌清洗方法。',
    card_05_text_04: '鋁、黃銅・銅等金屬和強鹼容易産生化學作用而変色、使用時要多加小心注意。（使用時必須加入添加劑）',
    card_05_text_05: '無法清除浴缸的霉菌。',
    footer_text_01: '家',
    footer_text_02: '創造安全安心的價値'
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/i18n/zh.js